// Copied from advisor-3.0/src/components/Layout/Sidebar.js
// Changes: Link from react-router-dom v7, TS types, useAccount for nav links
import { useEffect } from 'react';
import { SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';
import HelpCenter from 'src/components/HelpCenter/HelpCenter';
import { useCheckPermission, AccountSettings } from 'src/api/hooks/useAccount';
import HomeIcon from 'src/icons/home.svg';
import ActivityCenterIcon from 'src/icons/activity center.svg';
import ProductsIcon from 'src/icons/products.svg';
import BookOpenIcon from 'src/icons/BookOpen.svg';
import PremiumWholeIcon from 'src/icons/PremiumWhole.svg';
import './Sidebar.scss';

interface NavLinkItem {
  text: string;
  link: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  permission?: string;
}

interface SidebarProps {
  expanded: boolean;
  setExpanded: (value: boolean) => void;
}

export default function Sidebar({ expanded, setExpanded }: SidebarProps) {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const checkPermission = useCheckPermission();

  useEffect(() => {
    setExpanded(!isTabletOrMobile);
  }, [isTabletOrMobile, setExpanded]);

  const allNavLinks: NavLinkItem[] = [
    { text: 'Home', link: '/', icon: HomeIcon },
    { text: 'Activity Center', link: '/ActivityCenter', icon: ActivityCenterIcon },
    { text: 'Products', link: '/Products', icon: ProductsIcon },
    { text: 'Permanent Life Ins', link: '/PermanentLife', icon: PremiumWholeIcon, permission: 'enablePermPage' },
    { text: 'Resource Center', link: '/ResourceCenter', icon: BookOpenIcon, permission: 'enableResourceCenter' },
  ];

  const navLinks = allNavLinks.filter(
    (item) => !item.permission || checkPermission(item.permission as keyof AccountSettings),
  );

  const isActive = (link: string) => {
    if (link === '/') return location.pathname === '/';
    return location.pathname.startsWith(link);
  };

  return (
    <div
      id="advisor-sidebar"
      style={{
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        flexDirection: 'column',
      }}
      className={expanded ? 'advisor-sidebar-expanded' : 'advisor-sidebar-collapsed'}
    >
      <div id="sidenav-head">
        <img alt="Covr Logo" src="/AdvisorImages/covr-logo-white.svg" />
        {expanded ? (
          <SvgIcon component={MenuOpenIcon} style={{ cursor: 'pointer' }} onClick={() => setExpanded(false)} />
        ) : (
          <SvgIcon component={MenuIcon} style={{ cursor: 'pointer' }} onClick={() => setExpanded(true)} />
        )}
      </div>
      <div className="sidenav">
        {navLinks.map((item, index) => (
          <Link
            key={index}
            className={isActive(item.link) ? 'active' : ''}
            title={item.text}
            to={item.link}
          >
            <SvgIcon component={item.icon} color="secondary" />
            &nbsp;{expanded ? <span>{item.text}</span> : null}
          </Link>
        ))}
      </div>
      <HelpCenter expanded={expanded} />
    </div>
  );
}
